import { SubscriptionClient } from 'subscriptions-transport-ws';
import {
  cacheExchange,
  Client,
  createClient,
  dedupExchange,
  fetchExchange,
  subscriptionExchange,
} from 'urql';
import config from '../../../config';
import { errorExchange } from './error-handler/error-exchange';

const subscriptionClient = new SubscriptionClient(config.ws_api_url, {
  reconnect: true,
  timeout: 20000,

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  connectionCallback: (error: Error[], _result?: any) => {
    if (error && error.length) {
      console.log('Ws connection error: ', error);
    } else {
      console.log('Ws connection success to host: ', config.ws_api_url);
    }
  },
});

export const graphqlSubscriptionClient = subscriptionClient;

// eslint-disable-next-line @typescript-eslint/ban-types
export const defaultHeaders: {} = Object.freeze({
  'Content-Type': 'application/json',
});

export const createGraphqlClient = (): Client =>
  createClient({
    url: config.graphql_api_url,
    exchanges: [
      ...[dedupExchange, cacheExchange, errorExchange, fetchExchange],
      subscriptionExchange({
        forwardSubscription: (operation) => subscriptionClient.request(operation),
      }),
    ],
    fetchOptions: () => {
      return {
        credentials: 'include',
      };
    },
  });

let graphqlClient = createGraphqlClient();

export const resetGraphqlClient = (): Client => {
  const newClient = createGraphqlClient();
  graphqlClient = newClient;
  return newClient;
};

export default graphqlClient;
